import { Provider } from '@angular/core';

import { LogisticsManageVacationsRepositoryImpl } from '@app/data/repositories/manage-vacations/logistics/logistics-manage-vacations.repository';
import { LOGISTICS_MANAGE_VACATIONS_REPOSITORY } from '@app/domain/repositories/manage-vacations/logistics/logistics-manage-vacations.repository.contract';

export const logisticsManageVacationsRepositoryProvider: Provider = {
  provide: LOGISTICS_MANAGE_VACATIONS_REPOSITORY,
  useClass: LogisticsManageVacationsRepositoryImpl
};
